/**
 * @namespace {BX.UI}
 */
export default class AlertColor
{
	static DEFAULT = 'ui-alert-default';
	static DANGER = 'ui-alert-danger';
	static SUCCESS = 'ui-alert-success';
	static WARNING = 'ui-alert-warning';
	static PRIMARY = 'ui-alert-primary';
	static INFO = 'ui-alert-info';
}